import React from "react";
import {Box} from "@mui/material";
import { styled } from '@mui/material/styles';

import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 8,
    borderRadius: 4,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 500 : 200],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.primary.main,
    },

}));


const Fetching = () => (
    <Box className="fetching-progress">
        <BorderLinearProgress/>
    </Box>

);

export default Fetching;

